import React, {useState, useEffect} from 'react';
import {Modal, ModalHeader, ModalBody, Card, CardBody, Button, Input, Form, InputGroupText, InputGroup, Col, Row} from 'reactstrap';
import ContactComponent from './ContactComponent';
import DateTimePickerComponent from './DateTimePickerComponent';
import AllClearComponent from './AllClearComponent';

export default function ContactPopup({visible, toggle, logoSrc, mainText, headerText, footerText, accentColor, secondaryColor, goodbyeText, startingHour, endingHour, skipWeekends,
    phoneField,
    dateField,
    campaignId,
    apiAddress,
    workingHoursText
}){

    const [modalVisible, setModalVisible] = useState(true)
    const [modalStep, setModalStep] = useState("init");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [date, setDate] = useState("");
    
    useEffect(() => {
        setModalVisible(visible);
    }, [visible])

    const closeBtn = <div style={{backgroundColor: accentColor, color: secondaryColor, cursor: "pointer"}} onClick={toggle}>X</div>;

    function renderContent(){
        if(modalStep === 'init'){
            return <ContactComponent setPhoneNumber={(phone) => { setPhoneNumber(phone) }} setStep={(step) => setModalStep(step)} accentColor={accentColor} logoSrc={logoSrc} mainText={mainText} secondaryColor={secondaryColor} startingHour={startingHour} endingHour={endingHour} workingHoursText={workingHoursText}></ContactComponent>
        }else if (modalStep === 'date'){
            return <DateTimePickerComponent setDate={(date) => {setDate(date)}} skipWeekends={skipWeekends} startingHour={startingHour} endingHour={endingHour} mainText={mainText} logoSrc={logoSrc} setStep={(step) => setModalStep(step)} accentColor={accentColor} secondaryColor={secondaryColor}></DateTimePickerComponent>
        }else if(modalStep === 'end'){
            return <AllClearComponent apiAddress={apiAddress} phoneNumber={phoneNumber} date={date} campaignId={campaignId} dateField={dateField} phoneField={phoneField} setStep={(step) => setModalStep(step)} accentColor={accentColor} secondaryColor={secondaryColor} goodbyeText={goodbyeText}></AllClearComponent>
        } else if(modalStep === 'close'){            
            
            setModalStep('init');
            toggle();
        }
    }

    return (
        <>
            <Modal  isOpen={modalVisible} toggle={() => toggle()}>
                <ModalHeader style={{backgroundColor: accentColor, color: secondaryColor}} toggle={() => toggle()} close={closeBtn}>
                    {headerText}
                </ModalHeader>
                <ModalBody>
                    {renderContent()}                   
                    <div className="centered-div little-footer" style={{backgroundColor: accentColor, color: secondaryColor}}>
                        {footerText}
                    </div>
                </ModalBody>
            </Modal>
        </>
    );
}